import { Button, Modal, Tooltip } from "@material-ui/core";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { Edit3 } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { fdelete, fpatch } from "../../../API/callsAPI";
import { renderFieldContent } from "../../Utilities/CustomTableForAllTrackables/CustomTableBodyForAllTrackables";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import ShotVersionEditVersionModal from "../ShotVersionPageModals/ShotVersionEditVersionModal";
import useStyles from "./ShotVersionCustomTable.styles";

const ShotVersionCustomTable = ({
  shotVersionList,
  projectId,
  statusList,
  updateRefreshCounter,
  setSnackValue,
  allFieldsConfig,
  handleTableScroll,
  handleShotDetailModalState,
  sequenceId,
  shotID,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  taskList,
  fetchTasks,
  openCreateNewStatusModal,
  customFields,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [isEditShotVersionModalOpen, setEditShotVersionModalOpen] = useState({
    open: false,
    data: {},
  });

  const [isDeleteShotVersionModalOpen, setDeleteShotVersionModalOpen] =
    useState({
      open: false,
      data: {},
    });

  function handleEditShotVersionModalOpenState(e, data) {
    e?.stopPropagation();
    e?.preventDefault();
    setEditShotVersionModalOpen({
      open: !isEditShotVersionModalOpen.open,
      data: data,
    });
  }

  function handleDeleteShotVersionModalOpenState(e, data) {
    e?.stopPropagation();
    e?.preventDefault();
    setDeleteShotVersionModalOpen({
      open: !isDeleteShotVersionModalOpen.open,
      data: data,
    });
  }

  const handleDeleteShotVersion = async () => {
    try {
      await fdelete({
        url: `trackables/shot-version/${isDeleteShotVersionModalOpen.data?.id}/`,
      });

      updateRefreshCounter();
      setDeleteShotVersionModalOpen({
        open: false,
        data: {},
      });
      setEditShotVersionModalOpen({
        open: false,
        data: {},
      });
    } catch (error) {
      console.log(error);
    }
  };

  const rows = useMemo(
    () =>
      (shotVersionList?.results ?? []).map((res) => ({
        id: res.id,
        ...res,
      })),
    [shotVersionList?.results],
  );

  const handleValueChange = async (fieldName, value, id) => {
    try {
      const res = await fpatch({
        url: `trackables/shot-version/v2/${id}/`,
        data: {
          [fieldName]: value,
        },
      });
      if (res.status === 200 || res.status === 201) {
        updateRefreshCounter();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRowClick = (params, event) => {
    handleShotDetailModalState(params.row);
  };

  const columns = [
    ...(allFieldsConfig ?? []).map((field) => ({
      field: field.name,
      headerName: field.label || field.name,
      minWidth: 190,
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {renderFieldContent({
            field,
            props: { data: params.row },
            handleValueChange: (fieldName, value) =>
              handleValueChange(fieldName, value, params.row.id),
            index: 0,
            statusUrl: `trackables/asset-version/${params.row.id}/`,
            statusList,
            updateRefreshCounter,
          })}
        </div>
      ),
    })),
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        const data = params.row;
        return (
          <Tooltip title="Edit Asset" placement="top">
            <Button
              size="small"
              id="editshotversion"
              className={classes.inlineButtons}
              onClick={(e) => handleEditShotVersionModalOpenState(e, data)}
            >
              <Edit3 size={16} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box
      className={classes.assetsTableContainer}
      sx={{
        height:
          shotVersionList?.count > 50
            ? "calc(100vh - 230px)"
            : "calc(100vh - 200px)",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        onRowClick={handleRowClick}
        hideFooter
        sx={{
          width: "max-content",
          minWidth: "100%",
          border: "none",
          bgcolor: "transparent",
          "& .MuiDataGrid-root": {
            background: "#1B1D28 !important",
            color: "#606479 !important",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid #606479 !important",
            alignItems: "center",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
            backgroundColor: "#1B1D28",
            color: "#f9f9f9",
          },
          "& .MuiDataGrid-main": {
            minWidth: "max-content",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-window": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
          //
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              backgroundColor: "#1B1D28 !important",
              borderColor: "#606479",
              borderTop: "1px solid #606479",
              padding: "0px",
            },

          "--DataGrid-rowBorderColor": "#606479",
          "& .MuiDataGrid-columnHeaders": {
            color: "#606479",
            fontSize: {
              xs: "8px",
              sm: "10px",
              md: "12px",
              lg: "14px",
              xl: "16px",
            },
          },
        }}
        slots={{
          noRowsOverlay: () => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              No shots found.
            </Box>
          ),
        }}
      />
      <Modal
        className={classes.shotVersionPageModals}
        open={isEditShotVersionModalOpen.open}
        onClose={(e) => {
          setEditShotVersionModalOpen({
            open: false,
            data: {},
          });
        }}
      >
        <ShotVersionEditVersionModal
          data={isEditShotVersionModalOpen.data}
          sid={sequenceId}
          shotID={shotID}
          projectId={projectId}
          status={statusList}
          shotVersionId={isEditShotVersionModalOpen.data?.id}
          handleEditShotVersionModalOpenState={
            handleEditShotVersionModalOpenState
          }
          openDeleteShotVersionModal={handleDeleteShotVersionModalOpenState}
          updateRefreshCounter={updateRefreshCounter}
          dragScreen={dragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          taskList={taskList}
          fetchTasks={fetchTasks}
          customFields={customFields}
        />
      </Modal>

      <Modal
        className={classes.shotVersionPageModals}
        open={isDeleteShotVersionModalOpen.open}
        onClose={(e) => {
          setDeleteShotVersionModalOpen({
            open: false,
            data: {},
          });
        }}
      >
        <DeleteModal
          type="Shot Version"
          name={isDeleteShotVersionModalOpen.data?.name}
          handleCloseDeleteModal={() => {
            setDeleteShotVersionModalOpen({
              open: false,
              data: {},
            });
          }}
          handleDelete={handleDeleteShotVersion}
        />
      </Modal>
    </Box>
  );
};

export default ShotVersionCustomTable;
